module.exports = __webpack_public_path__ + "f20fc4311d50c20c5660cae72665c0ca.MP3";